module.exports = __webpack_public_path__ + "d797cc96bf5853d36a8f8a942931134f.svg";